/**
 * @description: 详情右侧列表组件
 * @author:
 */
<template>
  <div class="detail-list-table" :style="{minWidth: option.width || width}">
    <div class="row head">
      <template v-for="(item,index) in option.head">
        <div v-if="!(item.toggle && hide)" :key="item.prop" class="item" :style="{width: '100px', ...item.style||{}}">
          <span>{{item.label}}</span>
          <div class="detail-icon-box pointer-view" @click="hide=!hide" v-if="hideBtn && index === 0 && !item.label">
            <!--<i class="detail-icon iconfont iconzhankai icon-active" v-if="hide" />
            <i class="detail-icon iconfont iconshouqi1 icon-active" v-else />-->
            <el-button type="primary" size="mini">{{hide ? $lang('展开') : $lang('收起') }}</el-button>
          </div>
        </div>
      </template>
    </div>
    <div class="itemContent">
       <template v-if="!msg">
      <div v-for="(itemContent, index) in list" :key="index" class="c-item-content">
        <div class="row">
          <template v-for="item in option.head">
            <div v-if="!(item.toggle && hide)" :key="item.prop" class="item" :style="{width: '100px', ...item.style||{}}">
              <template v-if="item.prop === 'index'">
                {{index + 1}}
              </template>
              <template v-if="item.prop === 'detailIcon'">
                <div v-if="itemContent.detailCount" class="detail-icon-box pointer-view" @click="handleIndex(index, itemContent)">
                  <i class="detail-icon iconfont iconshouqi1 icon-active" v-if="detailIndex === index" />
                  <i class="detail-icon iconfont iconzhankai" v-else />
                  <div class="count-right">{{itemContent.detailCount}}</div>
                </div>
              </template>
              <template v-else-if="item.prop === 'showImg'">
                <span v-if="itemContent.showImg" class="link-color pointer-view" @click="getImgUrl(itemContent)">{{$lang('查看')}}</span>
              </template>
              <slot :name="`${item.prop}Slot`" v-else-if="item.slot" :item="itemContent" />
              <!-- 网点信息 -->
              <el-tooltip v-else-if="option.showNetInfo && item.prop === 'scanNetworkName'" class="item" effect="dark" placement="top"
                :disabled="!itemContent.customerServicePrincipal">
                <div slot="content" class="detail-tip-view">
                  <div>{{$lang('网点客服')}}: {{itemContent.customerServicePrincipal}}</div>
                  <div>{{$lang('联系方式')}}: {{itemContent.customerServiceTelephone}}</div>
                  <template v-if="itemContent.isAbnormal === 1">
                    <div>{{$lang('异常类型')}}: {{itemContent.abnormalTypeName}}</div>
                    <div>{{$lang('异常原因')}}: {{itemContent.abnormalCauses}}</div>
                    <!-- <div>{{$lang('解决时间')}}: {{itemContent.estimateTime}}</div> -->
                    <div>{{$lang('应对话术')}}: {{itemContent.speechcraft}}</div>
                    <div>{{$lang('异常解决方案')}}: {{itemContent.solution}}</div>
                    <div style="text-align: center" v-if="option.copyBtn">
                      <el-button type="primary" @click="handleCopy(itemContent.speechcraft)">{{$lang('复制')}}</el-button>
                    </div>
                  </template>
                </div>
                <span v-if="item.formatter && typeof item.formatter==='function'"
                  :class="{'text-red': itemContent.isAbnormal === 1}">{{itemContent[item.prop]}}</span>
                <span :class="{'text-red': itemContent.isAbnormal === 1}">
                  <template v-if="item.formatter && typeof item.formatter==='function'">{{item.formatter(itemContent)}}</template>
                  <template v-else>{{itemContent[item.prop]}}</template>
                </span>
              </el-tooltip>
              <!-- 物流轨迹查异常任务信息 -->
              <template v-else-if="item.prop==='waybillTrackingContent' && option.abnormalTask && (itemContent.taskList || itemContent.abnormalInfo)">
                {{itemContent.waybillTrackingContent.split(itemContent.remark2)[0]}}
                <el-tooltip effect="dark" placement="top" popper-class="show-max">
                  <template slot="content" v-if="!itemContent.abnormalInfo">
                    <div class="task-list-view head-view">
                      <template v-if="itemContent.abnormalSource === 2">
                        <div class="task-item-view">{{$lang('异常类型')}}</div>
                        <div class="task-item-view">{{$lang('持续时长（min）')}}</div>
                      </template>
                      <div class="task-item-view">{{$lang('规划到达时间')}}</div>
                      <div class="task-item-view">{{$lang('预计到达时间')}}</div>
                      <div class="task-item-view">{{$lang('任务状态')}}</div>
                      <div class="task-item-view">{{$lang('实际到达时间')}}</div>
                    </div>
                    <div class="task-list-view">
                      <div v-if="itemContent.abnormalSource === 2">
                        <div v-for="(item, i) in itemContent.taskList || []" :key="i" class="task-view">
                          <div class="task-item-view">{{item.exceptionType}}</div>
                          <div class="task-item-view">{{item.duration}}</div>
                        </div>
                      </div>
                      <div class="task-item-view">{{itemContent.plannedArrivalTime}}</div>
                      <div class="task-item-view">{{itemContent.predictArrivalTime}}</div>
                      <div class="task-item-view">{{shipmentState[itemContent.shipmentState] && shipmentState[itemContent.shipmentState].label}}</div>
                      <div class="task-item-view">{{itemContent.actualArrivalTime}}</div>
                    </div>
                  </template>
                  <template slot="content" v-else class="detail-tip-view">
                    <div>{{$lang('异常类型')}}: {{itemContent.abnormalInfo.abnormalTypeName}}</div>
                    <div>{{$lang('异常原因')}}: {{itemContent.abnormalInfo.abnormalCauses}}</div>
                    <!-- <div>{{$lang('解决时间')}}: {{itemContent.abnormalInfo.estimateTime}}</div> -->
                    <div>{{$lang('应对话术')}}: {{itemContent.abnormalInfo.speechcraft}}</div>
                    <div>{{$lang('异常解决方案')}}: {{itemContent.abnormalInfo.solution}}</div>
                    <div style="text-align: center">
                      <el-button type="primary" v-if="option.copyBtn" @click="handleCopy(itemContent.abnormalInfo.speechcraft)">{{$lang('复制')}}
                      </el-button>
                    </div>
                  </template>
                  <span :class="{'text-red': (itemContent.taskList.length || itemContent.abnormalInfo) && itemContent.abnormalSource}">{{itemContent.remark2}}</span>
                </el-tooltip>
                {{itemContent.waybillTrackingContent.split(itemContent.remark2)[1]}}
              </template>

              <template v-else-if="item.prop==='waybillTrackingContent' && option.showStopList && itemContent.stopList">
                {{itemContent.waybillTrackingContent.split(itemContent.remark2)[0]}}
                <el-tooltip effect="dark" placement="top" popper-class="show-max" :disabled="!itemContent.stopList.length">
                  <template slot="content">
                    <div class="task-list-view head-view">
                      <div class="task-item-view">{{$lang('经停信息')}}</div>
                      <div class="task-item-view">{{$lang('计划发车时间')}}</div>
                      <div class="task-item-view">{{$lang('司机签出时间')}}</div>
                      <div class="task-item-view">{{$lang('计划到车时间')}}</div>
                      <div class="task-item-view">{{$lang('司机签到时间')}}</div>
                    </div>
                    <div v-for="(item, i) in itemContent.stopList || []" :key="i" class="task-list-view">
                      <div class="task-item-view">{{item.networkName}}</div>
                      <div class="task-item-view">{{item.plannedDepartureTime}}</div>
                      <div class="task-item-view" :class="{'text-red': getstopListMax(item, 1)}">{{item.actualDepartureTime}}</div>
                      <div class="task-item-view">{{item.plannedArrivalTime}}</div>
                      <div class="task-item-view" :class="{'text-red': getstopListMax(item, 2)}">{{item.actualArrivalTime}}</div>
                    </div>
                  </template>
                  <span>{{itemContent.remark2}}</span>
                </el-tooltip>
                {{itemContent.waybillTrackingContent.split(itemContent.remark2)[1]}}
              </template>

              <template v-else-if="item.prop==='waybillTrackingContent' && option.showPackInfo && itemContent.packageNumber">
                {{itemContent.waybillTrackingContent.split(itemContent.packageNumber)[0]}}
                <el-tooltip effect="dark" placement="top" popper-class="show-max" :disabled="!itemContent.packageNumber">
                  <template slot="content">
                    <div class="task-list-view head-view">
                      <div class="task-item-view">{{$lang('建包名称')}}</div>
                      <div class="task-item-view">{{$lang('包内件总数')}}</div>
                    </div>
                    <div class="task-list-view">
                      <div class="task-item-view">{{itemContent.packageName}}</div>
                      <div class="task-item-view">{{itemContent.packageTotalCount}}</div>
                    </div>
                  </template>
                  <span>{{itemContent.packageNumber}}</span>
                </el-tooltip>
                {{itemContent.waybillTrackingContent.split(itemContent.packageNumber)[1]}}
              </template>

              <template v-else-if="item.prop==='waybillTrackingContent' && option.showNetLast && itemContent.nextStopName && itemContent.scanTypeName === $lang('发件扫描')">
                {{itemContent.waybillTrackingContent.split(itemContent.nextStopName)[0]}}
                <el-tooltip effect="dark" placement="top"
                  v-if="option.showNetLast && itemContent.showNetLast"
                  :disabled="!itemContent.showNetLast.customerServicePrincipal">
                  <div slot="content" class="detail-tip-view">
                    <div>{{$lang('网点客服')}}: {{itemContent.showNetLast.customerServicePrincipal}}</div>
                    <div>{{$lang('联系方式')}}: {{itemContent.showNetLast.customerServiceTelephone}}</div>
                    <template v-if="itemContent.showNetLast.isAbnormal === 1">
                      <div>{{$lang('异常类型')}}: {{itemContent.showNetLast.abnormalTypeName}}</div>
                      <div>{{$lang('异常原因')}}: {{itemContent.showNetLast.abnormalCauses}}</div>
                      <!-- <div>{{$lang('解决时间')}}: {{itemContent.showNetLast.estimateTime}}</div> -->
                      <div>{{$lang('应对话术')}}: {{itemContent.showNetLast.speechcraft}}</div>
                      <div>{{$lang('异常解决方案')}}: {{itemContent.showNetLast.solution}}</div>
                      <div style="text-align: center" v-if="option.copyBtn">
                        <el-button type="primary" @click="handleCopy(itemContent.showNetLast.speechcraft)">{{$lang('复制')}}</el-button>
                      </div>
                    </template>
                  </div>
                  <span>{{itemContent.nextStopName}}</span>
                </el-tooltip>
                <span v-else>{{itemContent.nextStopName}}</span>
                {{itemContent.waybillTrackingContent.split(itemContent.nextStopName)[1]}}
              </template>
              <template v-else-if="item.formatter && typeof item.formatter==='function'">
                <span v-if="item.html" v-html="item.formatter(itemContent)" />
                <template v-else>{{item.formatter(itemContent)}}</template>
              </template>

              <span v-else>{{itemContent[item.prop]}}</span>

            </div>
          </template>
        </div>
        <div class="detial-view" v-if="detailIndex === index">
          <slot name="detailView" :item="{}" />
        </div>
        <div class="detial-list" v-if="detailIndex === index">
          <slot name="detailList" :item="{}" />
        </div>
      </div>
      <div v-if="!list.length" class="none-date">{{$lang('暂无数据')}}</div>
      </template>
      <div v-else class="none-date" style="color: #e60012">{{msg}}</div>
    </div>
  </div>
</template>

<script>
import { detailView } from '../pool'
import { copyText } from '@/common/utils/tool'
import { DICT } from '@/common/utils/dict'
export default {
  data() {
    return {
      hide: this.hideInit,
      detailIndex: -1,
      popIndex: -1,
      infoData: {},
      shipmentState: DICT.shipmentState
    }
  },
  props: {
    option: Object,
    hideBtn: Boolean,
    hideInit: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array,
      default: () => []
    },
    width: {
      type: String,
      default: '1347px'
    },
    msg: {
      type: String,
      default: () => ''
    }
  },
  beforeMount() {
    this.initDetailIndex()
  },
  computed: {
    list() {
      console.log(this.value)
      return this.value.map((o, i) => ({
        ...o,
        // 物流轨迹有图
        showImg: o.remark2 === '1'
      }))
    }
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.detailIndex = -1
        this.initDetailIndex()
      }
    }
  },
  methods: {
    handleCopy(text) {
      copyText(text)
      // this.$bus.$emit('leftFormHandlingOpinions', text)
    },
    initDetailIndex() {
      // const frist = this.value[0]
      // if (frist && frist.detailCount > 0) {
      //   this.handleIndex(0, frist)
      // }
    },
    handleIndex(index, item) {
      if (this.detailIndex === index) {
        this.detailIndex = -1
      } else {
        this.detailIndex = index
        this.$emit('detailId', item.id)
        this.$emit('getItem', item)
      }
    },
    getstopListMax(item, index) {
      const isMax = (s1, s2) => {
        const t1 = new Date(s1).getTime()
        const t2 = new Date(s2).getTime()
        return t2 > t1
      }
      const { plannedDepartureTime, actualDepartureTime, plannedArrivalTime, actualArrivalTime } = item
      if (index === 1 && plannedDepartureTime && actualDepartureTime) {
        return isMax(plannedDepartureTime, actualDepartureTime)
      }
      if (index === 2 && plannedArrivalTime && actualArrivalTime) {
        return isMax(plannedArrivalTime, actualArrivalTime)
      }
      return false
    },
    getImgUrl(item) {
      detailView.reqReviewImage({
        waybillNo: item.waybillNo,
        scanTime: item.scanTime,
        scanByCode: item.scanByCode,
        imgType: item.imgType
      }).then(({ data }) => {
        this.handleShowImg(data || [])
      })
    },
    handlePopoverInfo(item, index) {
      this.popIndex = -1
      detailView.reqNetworkInfo({ networkId: item.scanNetworkId }).then(({ data }) => {
        this.infoData = data || {}
        this.popIndex = index
      })
    },
    handleShowImg(url = []) {
      const imgs = url.filter(o => o.match(/\.(jpe?g|png|gif)(\?\S+)?$/))
      this.$openImagePreview(imgs)
      url.map(file => {
        if (!file.match(/\.(jpe?g|png|gif)(\?\S+)?$/)) {
          // window.open(file)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-list-table {
  border: 1px solid #ddd;
  @include border-color('lighter');
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  overflow: hidden;
  // border-bottom-width: 0;
}
.row {
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  align-items: stretch;

  .item {
    float: left;
    word-break: break-all;
    white-space: normal;
    padding: 10px;
    font-size: 12px;
    line-height: 16px;
    // border-bottom: 1px solid;
    // @include border-color('lighter');
    &:not(:first-child) {
      border-left: 1px solid #ddd;
      @include border-color('lighter');
    }
  }
}
.head {
  // background-color: #efeff5;
  border-bottom: 1px solid;
  @include border-color('lighter');
  @include bg-color('pop-active');
  @include text-color('main');
  line-height: 40px;
  height: 40px;

  &.row .item {
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.itemContent {
  overflow: hidden;
  .c-item-content {
    border-top: 1px solid #ddd;
    @include border-color('lighter');
    @include text-color('routine');
    &:first-child {
      border-top-width: 0;
    }
  }
}
.detial-view {
  border-top: 1px solid #ddd;
  padding: 10px 40px 20px;
}
.detial-list {
  padding: 0px 40px 20px;
}

.detail-icon-box {
  font-size: 16px;
  position: relative;
  color: #fff;
  inset-inline: 0;

  .detail-icon {
    padding: 10px;
    color: #ddd;
    display: inline-block;
    &.icon-active {
      @include base-color('clr');
    }
    vertical-align: middle;
  }
  .count {
    position: absolute;
    font-size: 12px;
    @include base-color('bg');
    border-radius: 9px;
    line-height: 18px;
    padding: 0 5px;
    top: 8px;
    right: 8px;
    color: #fff;
    transform: scale(0.5);
    transform-origin: 100% 0;
  }
  .count-right {
    display: inline-block;
    vertical-align: middle;
    color: #fff;
    @include base-color('bg');
    font-size: 12px;
    line-height: 18px;
    border-radius: 9px;
    padding: 0 3px;
    min-width: 20px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
  }
}
.none-date {
  text-align: center;
  font-size: 12px;
  line-height: 60px;
  color: #909399;
  max-width: calc(100vw - 420px);
}

.detail-tip-view {
  max-width: 300px;
  div {
    word-break: break-all;
  }
}

.task-list-view {
  border-left: 1px solid;
  @include border-color('lighter');
}
.task-list-view,
.task-view {
  display: flex;
  &:not(:last-child) {
    border-bottom: 1px solid;
    @include border-color('lighter');
  }
  &.head-view {
    border-top: 1px solid;
    @include border-color('lighter');
  }
  .task-item-view {
    padding: 5px 0;
    text-align: center;
    width: 130px;
    border-right: 1px solid;
    @include border-color('lighter');
  }
}
</style>
